const createUserManagementFormData = () => ({
    userId: '',
    name: '',
    password: '',
    hubId: null,
    level: null,
    telephone: '',
    memo: '',
    useYn: '',
    resignationAt: null,
});
export default createUserManagementFormData;
